import styled from "@emotion/styled";
import {customDesktop, customMobile} from '../../globalStyleds';

const plaidTheme = (props) => `
  h1, h6, p, .buttonText {
    margin: 0;
    font-family: Roboto;
    font-style: normal;
  }

  h1 {
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    color: ${props.theme.palette.text.primary};
  }

  h6 {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color:${props.theme.palette.text.secondary};
  }

  p {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: ${props.theme.palette.text.secondary};
  }
`;

export const VerifyBankBodyWrapper = styled.div`
  height: 100%;
  .confirmationContent,
  .tcContent {
    background-color: ${props => props.theme.palette.background.paper};
    height: inherit;
    display: flex;
    flex-direction: column;
    color: ${props => props.theme.palette.text.primary};
    padding: 32px;
    justify-content: space-between;
  }

  .confirmationContent {
    height: calc(100% - 65px);
    .topSection{
      padding-top: 60px;
    }
    .textContent {
      h1 {
        margin-bottom: 16px;
      }
    }
    .bottomSection {
      .tcContainer {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 8px;
        b {
          text-decoration: underline;
        }
      }
    }
  }

  .tcContent {
    .topSection {
      display: flex;
      flex-direction: column;
      padding-top: 30px;
      height: calc(100% - 78px);
      .contentSection{
        .custom-content-list{
          ul {
            padding-left: 0;
            li {
              list-style: inside;
              margin: 10px 0;
            }
          }
        }
        .custom-table{
          overflow-x: auto;
          table{
            margin-top: 15px;
            width: 100%;
            border-collapse: collapse;
            border: 1px solid ${props => props.theme.palette.divider};
            tr {
              background-color: ${props => props.theme.palette.action.paper};
              th, td {
                padding: 8px;
                border: 1px solid ${props => props.theme.palette.divider};
                text-align: center;
              }
              th {
                font-weight: bold;
                color: ${props => props.theme.palette.text.primary};
              }
            }
          }
        }
        .echeck-terms-of-use-class {
          font-weight: normal;
          font-size: 16px;
          line-height: 24px;
          color: ${props => props.theme.palette.text.secondary};
          strong {
            color: ${props => props.theme.palette.text.primary};
            font-weight: bold;
          }
          a {
            color: inherit;
          }
          ul {
            margin: 0;
            padding-left: 2rem;
            text-align: left;
          }
          li {
            margin: 0;
            padding: 0;
          }
        }
 
        h1, h2, h3, h4 {
          color: ${props => props.theme.palette.text.primary};
        }
        p, li{
          color: ${props => props.theme.palette.text.secondary};
          font-weight: normal;
        }
        h1{
          margin-bottom: 16px;
        }
        h2{
          text-align: center;
          font-size: 20px;
        }
        h3{
          font-size: 18px;
          font-weight: 400;
          text-transform: uppercase;
        }
        h4 {
          font-size: 16px;
          text-transform: uppercase;
          margin-bottom: 4px;
        }
        p{
          font-weight: 400;
          line-height: 24px;
        }
        overflow-y: scroll;
        height: 100%;
      }
    }
  }
  
  h1.header {
    margin-bottom: 10px;
    font-size; 22px;
  }
  
  div.infoBox {
    display: flex;
    justify-content: space-between;
  }
  
  .bankBranding {
    margin: 25px 0 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    h1 {
      margin-left: 10px;
    }
    img {
      height: 50px;
    }
  }
  
  .divider {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid ${props => props.theme.palette.divider};;
    margin: 0;
    margin-bottom: -10px;
    margin-top: -10px;
  }
  
  p.key {
    font-size: 14px;
    color: ${props => props.theme.palette.text.secondary};
  }
  
  p.value {
    font-size: 20px;
    color: ${props => props.theme.palette.text.primary};
  }
  
  .subText {
    margin-top: -20px;
    color: ${props => props.theme.palette.text.secondary};
    font-size: 12px;
  }
  
  .mt-15 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  
  .mt-n15 {
    margin-top: -15px;
    margin-bottom: -15px;
  }
  
  .text-center {
    text-align: center;
    .underline {
      text-decoration: underline;
    }
  }

  ${props => plaidTheme(props)}
`;

export const DepositWrapperStyled = styled.div`
  width: 100vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.customStyle.isMobile ? customMobile : customDesktop}
`;

export const ConfirmedStyled = styled.div`
  text-align: center;
  img{
    width: 53px;
    height: 53px;
    margin-top: 57px;
  }
  h2{
    margin-top: 16px;
    font-size: 24px;
  }
`;

export const StyledBankLogo = styled.img`
  padding-bottom: 32px;
`;
